import colors from 'vuetify/util/colors';
import { AppColors } from '@/themes/theme';

export const dpmpColors: Partial<AppColors> = {
  systemPrimary: '#E40613', // see RDP-1528
  systemSecondary: '#073855', // see RDP-1528
  buttonPrimary: '#073855', // see RDP-1528
  primary: colors.blue.darken4, // see RDP-1529
  buttonWarning: colors.red.lighten1,
  buttonConfirm: colors.green.darken2,
  buttonDefault: colors.grey.darken1,
  rdpbackground: '#d4d4d4',
  leftpanelhover: '#c46064',
};
